import { HttpErrorResponse } from '@angular/common/http';

export namespace NotificationsActions {
  /**
   * @action ChangeSidebarVisible
   */
  export class ChangeSidebarVisible {
    static type = '[Notifications] ChangeVisibility';
    constructor(public sidebarVisible: boolean) {}
  }

  /**
   * @action GetNotifications
   */
  export class GetNotifications {
    static type = '[Notifications] GetNotifications';
    constructor(public page?: number, public filter?: string[]) {}
  }
  export class GetNotificationsSuccess {
    static type = '[Notifications] GetNotificationsSuccess';
  }
  export class GetNotificationsFailed {
    static type = '[Notifications] GetNotificationsFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  /**
   * @action Blockers
   */

  export class CheckBlockers {
    static type = '[Notifications] CheckBlockers';
  }

  /**
   * @action MarkAsRead
   */
  export class MarkAsRead {
    static type = '[Notifications] MarkAsRead';
    constructor(public notificationIds: number[]) {}
  }
  export class MarkAsReadSuccess {
    static type = '[Notifications] MarkAsReadSuccess';
  }
  export class MarkAsReadFailed {
    static type = '[Notifications] MarkAsReadFailed';
    constructor(public error?: HttpErrorResponse) {}
  }

  export class MarkAsReadAll {
    static type = '[Notifications] MarkAsReadAll';
  }
  export class MarkAsReadAllSuccess {
    static type = '[Notifications] MarkAsReadAllSuccess';
  }
  export class MarkAsReadAllFailed {
    static type = '[Notifications] MarkAsReadAllFailed';
    constructor(public error?: HttpErrorResponse) {}
  }
}
